import "./index.moduleRenamed.css";

export const wrapper = "index-module__wrapper___tyDnv";
export const menuItem = "index-module__menuItem___vErsw";
export const isDisabled = "index-module__isDisabled___d3l2n";
export const isBusy = "index-module__isBusy___OWPLK";
export const ucAnimMenuItemBusying = "index-module__ucAnimMenuItemBusying___qVmjI";
export const menuItemSeparator = "index-module__menuItemSeparator___QPOUd";
export const itemText = "index-module__itemText___DJ0oB";
export const checkMark = "index-module__checkMark___hi5zj";
export const isHidden = "index-module__isHidden___vYVoo";
export const menuSection = "index-module__menuSection___31PwQ";
export const menuSectionTitle = "index-module__menuSectionTitle___CSyFe";
export const menuItemList = "index-module__menuItemList___uJv6T";
export const menuSectionArea = "index-module__menuSectionArea___-4Zzh";
export const reverse = "index-module__reverse___0fBrU";

export default {
  wrapper: "index-module__wrapper___tyDnv",
  menuItem: "index-module__menuItem___vErsw",
  isDisabled: "index-module__isDisabled___d3l2n",
  isBusy: "index-module__isBusy___OWPLK",
  ucAnimMenuItemBusying: "index-module__ucAnimMenuItemBusying___qVmjI",
  menuItemSeparator: "index-module__menuItemSeparator___QPOUd",
  itemText: "index-module__itemText___DJ0oB",
  checkMark: "index-module__checkMark___hi5zj",
  isHidden: "index-module__isHidden___vYVoo",
  menuSection: "index-module__menuSection___31PwQ",
  menuSectionTitle: "index-module__menuSectionTitle___CSyFe",
  menuItemList: "index-module__menuItemList___uJv6T",
  menuSectionArea: "index-module__menuSectionArea___-4Zzh",
  reverse: "index-module__reverse___0fBrU",
};